import { render, staticRenderFns } from "./TargetBuildsPlatformsTable.vue?vue&type=template&id=15d2d090&scoped=true"
import script from "./TargetBuildsPlatformsTable.vue?vue&type=script&lang=js"
export * from "./TargetBuildsPlatformsTable.vue?vue&type=script&lang=js"
import style0 from "./TargetBuildsPlatformsTable.vue?vue&type=style&index=0&id=15d2d090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2d090",
  null
  
)

export default component.exports